import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/views/Home.vue";

import { Create } from "./modules/create";
 
import { ObjectPages } from "./modules/objectPage/index"; 
 
import SystemConfig from "./modules/system/index";

import { ReportsPage } from './modules/reportPage'

import { ImportFilesPage } from "./modules/importFilesPage";

import { WorkBench } from "./modules/workBench";
 import { TestPage } from "./modules/test";
import { ScheduleTask } from "./modules/scheduleTask";

import { loginPage } from "./modules/login";

Vue.use(VueRouter);

const { Config } = SystemConfig;
 
 
const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  ...loginPage,

  {
    path: "/home",
    component: Home,
    meta: {
      title: "Swift",
    },
    // redirect: '/echarts',
    children: [
      ...ObjectPages,

      ...WorkBench,
      ...Create,
      ...Config,
      ...ScheduleTask,
      ...ReportsPage,
      ...ImportFilesPage,
      ...TestPage,
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// import store from '@/store' //引入store

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();

  // if (!store.state.pageChanged) {
  // 	next();
  // } else {
  // 	var r = confirm("当前页面有未保存信息，确定离开么");
  // 	if (r)	{
  // 		// store.state.pageChanged = false;
  // 		store.commit('setPageChanged',false)
  // 		next()
  // 	}	else{
  // 		return
  // 	}
  // }
});

//路由导航守卫
// router.beforeEach((to, from, next) => {

//   const token = window.localStorage.getItem('JWT_TOKEN');
//   if (to.path == '/login') {
//     if(!token){
//       return next();
//     }else{
//       return next({path: '/home'})
//     }
//   }

//   if(to.path=='/401'){
// 	  return next();
//   }

//   if (!token) {
//     return next('/login');
//   }else {
//     //判断是否有访问该路径的权限
//     const urls =store.state.userInfo.url;
//     //如果是管理员
//     if(store.state.userInfo.isAdmin){
//        return next();
//     }else{
//       if(urls.indexOf(to.path) > -1){
//         //则包含该元素
//         window.sessionStorage.setItem("activePath", to.path);
//         return next();
//       }else{
//         return next("/401");
//       }
//     }
//   }
// })

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
